import { getODataEQFilterFrom } from '@utils/odata';
import { PipelineTemplatesCategory } from '@redux/types/types';

export const TEMPLATE_CATEGORY_TAGS = {
  [PipelineTemplatesCategory.RECOMMENDED]: 'category:recommended',
  [PipelineTemplatesCategory.DOCUMENT_SEARCH]: 'category:document search',
  [PipelineTemplatesCategory.BASIC_QA]: 'category:basic qa',
  [PipelineTemplatesCategory.VISUAL_QA]: 'category:visual qa',
  [PipelineTemplatesCategory.CONVERSATIONAL]: 'category:conversational',
  [PipelineTemplatesCategory.TEXT_ANALYSIS]: 'category:text analysis',
  [PipelineTemplatesCategory.TEXT_TO_SQL]: 'category:text to sql',
  [PipelineTemplatesCategory.IMAGE_GENERATION]: 'category:image generation',
  [PipelineTemplatesCategory.AGENTS]: 'category:agents',
  [PipelineTemplatesCategory.OCR]: 'category:ocr',
  [PipelineTemplatesCategory.AI_ENHANCED]: 'category:ai enhanced',
  [PipelineTemplatesCategory.VISUAL_PROCESSING]: 'category:visual processing',
};

export const removeTemplatesTagPrefixes = (tag: string) => {
  const [, tagWithoutPrefix] = tag.split(':');
  return tagWithoutPrefix || tag;
};

export const getTagsNameFilter = (tagName: string) => {
  return `tags/any(tag: ${getODataEQFilterFrom('tag/name', tagName)})`;
};

export const getTagsNameFilterByCategory = (category: PipelineTemplatesCategory) => {
  return getTagsNameFilter(TEMPLATE_CATEGORY_TAGS[category]);
};

export const getTemplateFilterByCategory = (category: PipelineTemplatesCategory) => {
  const filtersByCategoryMap: Record<PipelineTemplatesCategory, string> = Object.values(
    PipelineTemplatesCategory,
  ).reduce((acc, value) => {
    acc[value] = getTagsNameFilterByCategory(value);
    return acc;
  }, {} as Record<PipelineTemplatesCategory, string>);

  return filtersByCategoryMap[category];
};
